'use client';

import { HStack } from '@terra/ui-styled-system';
import { Text } from '../../../components/styled/text';
import type { OnOpenChatObject } from './hitl-types';
import {
  getPortalObjectResultLabel,
  type PortalObjectResult,
} from '../utils/portal-object-result';

type PortalObjectToolResultRowProps = {
  label: string;
  portalObjectResult: PortalObjectResult;
  onOpenObject: OnOpenChatObject;
};

export function PortalObjectToolResultRow({
  label,
  portalObjectResult,
  onOpenObject,
}: PortalObjectToolResultRowProps) {
  const displayLabel = getPortalObjectResultLabel({
    label,
    objectType: portalObjectResult.objectType,
  });

  const handleOpenObject = () => {
    onOpenObject({
      type: portalObjectResult.objectType,
      id: portalObjectResult.objectId,
      label: portalObjectResult.title,
    });
  };

  return (
    <HStack
      gap={1.5}
      alignItems="center"
      width="100%"
      pl={4}
      pr={2}
      py={0.5}
      cursor="pointer"
      onClick={handleOpenObject}
    >
      <Text
        fontSize="xs"
        fontFamily="mono"
        color="fg.muted"
        truncate
        minWidth={0}
      >
        {displayLabel}
      </Text>
      {portalObjectResult.title ? (
        <Text
          fontSize="xs"
          color="fg.default"
          truncate
          minWidth={0}
          flex={1}
          textAlign="right"
        >
          {portalObjectResult.title}
        </Text>
      ) : null}
    </HStack>
  );
}
